import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({children,condition})=>{

    const token = localStorage.getItem('accessToken')

    // return token ? children: <Navigate to='/'/>
     // If a custom condition is provided, use it; otherwise, check the token
  const isAuthorized = condition !== undefined ? condition : !!token;

  return isAuthorized ? children : <Navigate to="/" />;

}
export default PrivateRoute;